<mat-sidenav-container class="sidenav-container">
  <!-- Sidebar -->
  <mat-sidenav
    #sidenav
    [mode]="isHandset ? 'over' : 'side'"
    [opened]="isSidenavOpened"
    [class.closed]="!isSidenavOpened"
    class="my-menu-sidenav"
    *ngIf="true"
  >
    <div class="sidenav-menu">
      <button
        mat-button
        routerLink="/home"
        routerLinkActive="active"
        (click)="closeSidenavIfHandset()"
      >
        <mat-icon>home</mat-icon>
        <span>Home</span>
      </button>

      <button
        mat-button
        routerLink="/chat"
        routerLinkActive="active"
        (click)="closeSidenavIfHandset()"
      >
        <mat-icon>chat</mat-icon>
        <span>{{ chatMenuTitle }}</span>
      </button>
      
      <button
        mat-button
        routerLink="/tutors"
        routerLinkActive="active"
        (click)="closeSidenavIfHandset()"
      >
        <mat-icon>groups</mat-icon>
        <span>Tutors</span>
      </button>

      <button
        mat-button
        routerLink="/conversations"
        routerLinkActive="active"
        (click)="closeSidenavIfHandset()"
      >
        <mat-icon>history</mat-icon>
        <span>Conversations</span>
      </button>

      <button
        mat-button
        routerLink="/workspaces"
        routerLinkActive="active"
        (click)="closeSidenavIfHandset()"
        *ngIf="showWorkspaces"
      >
        <mat-icon>hub</mat-icon>
        <span>Workspaces</span>
      </button>

      <button
        mat-button
        routerLink="/profile"
        routerLinkActive="active"
        (click)="closeSidenavIfHandset()"
        *ngIf="true"
      >
        <mat-icon>person</mat-icon>
        <span>Profile</span>
      </button>

      <button
        mat-button
        routerLink="/prompts"
        routerLinkActive="active"
        (click)="closeSidenavIfHandset()"
        *ngIf="false"
      >
        <mat-icon>format_list_bulleted</mat-icon>
        <span>Instructions</span>
      </button>

      <button
        mat-button
        routerLink="/projects"
        routerLinkActive="active"
        (click)="closeSidenavIfHandset()"
        *ngIf="showProjects"
      >
        <mat-icon>perm_media</mat-icon>
        <span>Projects</span>
      </button>

      <button
        mat-button
        routerLink="/analytics"
        routerLinkActive="active"
        (click)="closeSidenavIfHandset()"
        *ngIf="showAnalytics"
      >
        <mat-icon>analytics</mat-icon>
        <span>Analytics</span>
      </button>

      <button
        mat-button
        routerLink="/agents"
        routerLinkActive="active"
        (click)="closeSidenavIfHandset()"
        *ngIf="showAgents"
      >
        <mat-icon>engineering</mat-icon>
        <span>Agents</span>
      </button>

      <button
        mat-button
        routerLink="/test"
        routerLinkActive="active"
        (click)="closeSidenavIfHandset()"
        *appHasRole="'superadmin'"
      >
        <mat-icon>bug_report</mat-icon>
        <span>Test Bench</span>
      </button>

      <div class="spacer"></div>

      <button
        mat-button
        routerLink="/settings"
        routerLinkActive="active"
        (click)="closeSidenavIfHandset()"
      >
        <mat-icon>settings</mat-icon>
        <span>Settings</span>
      </button>
    </div>
  </mat-sidenav>

  <!-- Main Content -->
  <mat-sidenav-content class="sidenav-content">
    <div class="sidenav-content-wrapper">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
